var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"custom-google-button"},on:{"click":function($event){return _vm.handleButtonClick()}}},[_c('span',{staticClass:"icon"}),_c('span',{staticClass:"button-text"},[_vm._v("Google")])])
}
var staticRenderFns = []

export { render, staticRenderFns }